import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../config/storage-keys';
import { LocalUser } from '../model/localUser.model';
import { User } from '../model/user.model';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getLocalUser() : LocalUser {
    let user = localStorage.getItem(STORAGE_KEYS.localUser);
    if (user === null) {
      return null;
    } else {
      return JSON.parse(user);
    }    
  }

  setLocalUser(obj: LocalUser) {

    if (obj === null) {
      localStorage.removeItem(STORAGE_KEYS.localUser);
    } else {
      localStorage.setItem(STORAGE_KEYS.localUser, JSON.stringify(obj));
    }
  }

  getUserLogged() : User {
    let user = localStorage.getItem(STORAGE_KEYS.userLogged);
    if (user === null) {
      return null;
    } else {
      return JSON.parse(user);
    }    
  }

  setUserLogged(obj: User) {

    if (obj === null) {
      localStorage.removeItem(STORAGE_KEYS.userLogged);
    } else {
      localStorage.setItem(STORAGE_KEYS.localUser, JSON.stringify(obj));
    }
  }
}


